import Component from './InstagramAnalyticsPublicSummary.vue'
export default Component
